
export interface OfferMeta {
  slug: string;
  heading: string;
  description: string;
}

interface OfferListItemProps {
  offerMeta: OfferMeta;
  listPosition: number;
}

function getOfferURL(slug: string, listPosition: number): string {
  return `/go/${slug}?lp=${listPosition}`;
}

export function OfferListItem({offerMeta, listPosition}: OfferListItemProps) {
  return (
    <li className="py-3 hover:bg-gray-50 dark:hover:bg-gray-700" title="Sponsored listing">
      <a href={getOfferURL(offerMeta.slug, listPosition)} target="_blank" rel="noopener noreferrer sponsored" aria-label={`Sponsored: ${offerMeta.heading}`}>
        <div className="text-lg">{offerMeta.heading} • Ad</div>
        <div className="text-sm text-rr-medium">{offerMeta.description}</div>
      </a>
    </li>
  );
}